const LineGraphConfig = {
	hover: {
		intersect: false,
		mode: 'index',
	},
	legend: {
		display: false,
	},
	scales: {
		xAxes: [
			{
				gridLines: {
					display: false,
					drawBorder: false,
				},
				ticks: {
					fontColor: '#787878',
					maxRotation: 0,
					maxTicksLimit: 6,
					minRotation: 0,
					padding: 10,
				},
			},
		],
		yAxes: [
			{
				display: true,
				gridLines: {
					borderDash: [2, 1],
					drawBorder: false,
				},
				position: 'left',
				ticks: {
					fontColor: '#787878',
					maxTicksLimit: 3,
					padding: 5,
				},
			},
		],
	},
	tooltips: {
		callbacks: {},
		enabled: false,
		intersect: false,
		mode: 'index',
		position: 'average',
	},
};

export default LineGraphConfig;
